import { getExperiment } from '@eventbrite/statsig';
import { useEffect } from 'react';
import { LISTINGS_HERO_AUTOSLIDE_EXPERIMENT } from '../../../../experimentation/constants';
import type { CarouselItems } from './index';

const AUTOSLIDE_INTERVAL_MS = 8000;

type UseAutoSliderProps = (
    items: CarouselItems[],
    nextSlide: () => void,
) => void;

export const useAutoSlider: UseAutoSliderProps = (items, nextSlide) => {
    const enableAutoSlide =
        items.length > 1 &&
        getExperiment(
            LISTINGS_HERO_AUTOSLIDE_EXPERIMENT.experimentName,
            LISTINGS_HERO_AUTOSLIDE_EXPERIMENT.param,
            LISTINGS_HERO_AUTOSLIDE_EXPERIMENT.defaultValue,
        );

    useEffect(() => {
        if (!enableAutoSlide) {
            return;
        }
        const autoSlideInterval = setInterval(() => {
            nextSlide();
        }, AUTOSLIDE_INTERVAL_MS);
        return () => {
            clearInterval(autoSlideInterval);
        };
    }, [enableAutoSlide, items.length, nextSlide]);
};
